import { render, staticRenderFns } from "./EnterpriseId.vue?vue&type=template&id=222068ce&scoped=true&"
import script from "./EnterpriseId.vue?vue&type=script&lang=ts&"
export * from "./EnterpriseId.vue?vue&type=script&lang=ts&"
import style0 from "./EnterpriseId.vue?vue&type=style&index=0&id=222068ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222068ce",
  null
  
)

export default component.exports